import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { GlideComponent } from "./glide/glide.component";

export const GLOBAL_GLIDE_DIRECTIVES: any[] = [GlideComponent];

@NgModule({
	imports: [CommonModule, GlobalUiModule],
	exports: GLOBAL_GLIDE_DIRECTIVES,
	declarations: GLOBAL_GLIDE_DIRECTIVES,
})
export class GlobalUiGlideModule {}
